module.exports = __webpack_public_path__ + "img/cre-landing-banner.13af7b18.jpg";